function e(e){return(new TextDecoder).decode(e)}function n(e){return(new TextEncoder).encode(e)}export{e as decode,n as encode};
//# sourceMappingURL=utf8.browser.js.map
